import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, ConfigProvider, notification, InputNumber, Radio, Checkbox, Result, DatePicker, Select } from 'antd';
import { Link, useSearchParams } from 'react-router-dom';
import { CloseCircleOutlined, CheckCircleFilled } from '@ant-design/icons';
import changeHeight from '../data/changeHeight';
import axios from 'axios';
import dayjs from 'dayjs';
import esES from 'antd/es/locale/es_ES';
import locale from 'antd/es/date-picker/locale/es_ES';
import bancos from '../data/banco';

dayjs.locale('es');

const { TextArea } = Input;
const { Option } = Select;

const FormPhishing = () => {
    const [buttonLoading, setButtonLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [primaryColor, setPrimaryColor] = useState('#FFFFFF');
    const [urlParent, setUrlParent] = useState(null);
    const [searchParams] = useSearchParams();
    const [form] = Form.useForm();
    const refForm = useRef(0);
    const refResult = useRef(0);
    const [result, setResult] = useState("collapse");
    const [heightResult, setHeightResult] = useState(0);
    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        if (searchParams.get("primaryColor")) {
            setPrimaryColor('#' + searchParams.get("primaryColor"));
            setResult("none");
            setHeightResult(refResult.current?.clientHeight || 0);
        }
        if (searchParams.get("parentUrl")) {
            setUrlParent(searchParams.get("parentUrl"));
            form.setFieldsValue({ url: decodeURIComponent(searchParams.get("parentUrl")) });
        }
    }, [searchParams, form]);

    useEffect(() => {
        const element = refForm.current;
        if (!element) return;

        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.target === element) {
                    changeHeight(entry.target.clientHeight);
                    break;
                }
            }
        });
        resizeObserver.observe(element);
        return () => {
            resizeObserver.unobserve(element);
        };
    }, []);

    window.addEventListener('message', (event) => {
        if (event.data.type === "from-parent") {
            if (event.data.fbp === 'null' || event.data.fbp === null || event.data.fbp === undefined) {
                form.setFieldsValue({ fbp: " " });
            } else {
                form.setFieldsValue({ fbp: event.data.fbp });
            }
            if (event.data.hubspotutk === 'null' || event.data.hubspotutk === null || event.data.hubspotutk === undefined) {
                form.setFieldsValue({ hubspotutk: " " });
            } else {
                form.setFieldsValue({ hubspotutk: event.data.hubspotutk });
            }
            if (event.data.userAgent) { form.setFieldsValue({ userAgent: event.data.userAgent }); }
            changeHeight(refForm.current.clientHeight);
        }
    });

    const onFinish = (values) => {
        setButtonLoading(true);
        axios.post('https://n8n-615087458109.europe-southwest1.run.app/webhook/29435d66-7047-4605-a31c-ae7f75bce521', values, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then(function (response) {
                if (response.status === 200 || response.status === 201) {
                    setButtonLoading(false);
                    setSuccess(true);
                    setResult("block");
                    changeHeight(heightResult);
                } else {
                    throw new Error('Error en la respuesta del servidor');
                }
            })
            .catch(function () {
                openNotification('bottomRight');
                setButtonLoading(false);
            });
    };

    const openNotification = () => {
        api.info({
            message: 'Error inesperado',
            description: 'Ha ocurrido un error inesperado. Inténtelo más tarde. Disculpe las molestias',
            placement: 'bottomRight',
            icon: <CloseCircleOutlined style={{ color: "#f7151c" }} />
        });
    };

    const disableDateAfterToday = (current) => current && current >= dayjs().endOf('day');

    const customParser = (value) => {
        // Reemplaza comas por puntos
        const processedValue = value.replace(/,/g, '.');
      
        // Analiza el valor en un número de punto flotante
        const parsedValue = parseFloat(processedValue);
      
        // Asegúrate de que el resultado es un número
        if (!isNaN(parsedValue)) {
          return parsedValue;
        }
      
        return undefined; // Si no se pudo analizar, devuelve undefined
    };

    return (
        <>
            {contextHolder}
            <ConfigProvider
                locale={esES}
                theme={{
                    token: {
                        colorPrimary: primaryColor,
                    },
                }}
            >
                <style>{`::-webkit-scrollbar { display: none; }`}</style>

                <div ref={refForm}>
                    {!success ? (
                        <Form form={form} style={{ padding: '1.5rem' }} hidden={success} name="phishing" initialValues={{ remember: true, url: urlParent }} layout='vertical' onFinish={onFinish} requiredMark={false}>
                            <Form.Item hidden={true} label="URL" name="url"><Input type='text' /></Form.Item>
                            <Form.Item hidden={true} label="FB" name="fbp"><Input type='' /></Form.Item>
                            <Form.Item hidden={true} label="Hubspotutk" name="hubspotutk"><Input type='' /></Form.Item>
                            <Form.Item hidden={true} label="userAgent" name="userAgent"><Input type='' /></Form.Item>

                            <Form.Item label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Teléfono *</p>} name="telefono" style={{ marginBottom: "0.6rem" }} rules={[{ required: true, message: 'Por favor, ingresa tu teléfono' }, { len: 9, message: 'El teléfono debe tener 9 dígitos' }]}>
                                <Input maxLength={9} minLength={9} placeholder='619 99 31 31' type='tel' disabled={buttonLoading} />
                            </Form.Item>

                            <Form.Item label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Email *</p>} name="email" style={{ marginBottom: "0.6rem" }} rules={[{ required: true, message: 'Por favor, ingresa tu email' }, { type: 'email', message: 'El email no es válido' }]}>
                                <Input placeholder='tunombre@gmail.com' type='email' disabled={buttonLoading} />
                            </Form.Item>

                            <Form.Item label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Banco *</p>} name="banco" style={{ marginBottom: "0.6rem" }} rules={[{ required: true, message: 'Por favor, escoge tu banco' }]}>
                                <Select showSearch placeholder='Escoge tu banco' disabled={buttonLoading}>
                                    {bancos.map((banco) => (
                                        <Option key={banco} value={banco}>{banco}</Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Fecha del robo *</p>} name="fecha_robo" style={{ marginBottom: "0.6rem" }} rules={[{ required: true, message: 'Por favor, ingresa la fecha del robo' }]}>
                                <DatePicker
                                    style={{ width: '100%' }}
                                    locale={locale}
                                    disabled={buttonLoading}
                                    format="DD/MM/YYYY"
                                    showToday={false}
                                    disabledDate={disableDateAfterToday}
                                    placeholder="dd/mm/yyyy"
                                />
                            </Form.Item>

                            <Form.Item label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Cuantía sustraída *</p>} name="cuantia_sustraida" style={{ marginBottom: "0.6rem" }} rules={[{ required: true, message: 'Por favor, ingresa la cuantía sustraída' }, { type: 'number', min: 0, message: 'La cuantía debe ser un número positivo' }]}>
                                <InputNumber style={{ width: '100%' }} placeholder='19000' disabled={buttonLoading} parser={customParser} />
                            </Form.Item>

                            <Form.Item label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Has denunciado el caso? *</p>} name="ha_denunciado" style={{ marginBottom: "0.6rem" }} rules={[{ required: true, message: 'Por favor, indica si has denunciado el caso' }]}>
                                <Radio.Group disabled={buttonLoading}>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Cuéntanos tu caso *</p>} name="caso" style={{ marginBottom: "0.6rem" }} rules={[{ required: true, message: 'Por favor, cuéntanos tu caso' }]}>
                                <TextArea rows={6} placeholder='Describe tu caso aquí...' disabled={buttonLoading} />
                            </Form.Item>

                            <Form.Item style={{ marginBottom: "0.6rem" }} valuePropName="checked" name="terms" initialValue={false} rules={[{ required: true, validator: async (_, checked) => { if (!checked) { return Promise.reject(new Error("Por favor, acepta los términos y condiciones")); } } }]}>
                                <Checkbox style={{ fontSize: "15px" }} disabled={buttonLoading}>Acepto los <Link target='_blank' to='https://www.coventia.es/politica-de-privacidad-y-aviso-de-cookies'>términos y condiciones</Link></Checkbox>
                            </Form.Item>

                            <Form.Item style={{ marginBottom: "0.6rem", width: '100%', marginTop: '1rem' }}>
                                <Button type='primary' loading={buttonLoading} htmlType="submit" style={{ width: "100%", height: "35px" }}>
                                    {buttonLoading ? 'Enviando...' : 'Enviar'}
                                </Button>
                            </Form.Item>
                        </Form>
                    ) : null}
                    <div ref={refResult}>
                        <div style={{ display: `${result}` }}>
                            <Result
                                icon={<CheckCircleFilled style={{ color: primaryColor }} />}
                                style={{ padding: '1.5rem', paddingTop: '3rem' }}
                                status="success"
                                title="¡Gracias!"
                                subTitle={<span dangerouslySetInnerHTML={{ __html: "Tu información ha sido enviada correctamente.<br/>En breve nos pondremos en contacto contigo." }} />}
                            />
                        </div>
                    </div>
                </div>
            </ConfigProvider>
        </>
    );
};

export default FormPhishing;

